<script>
    import { dataset_dev } from "svelte/internal";
  import "../../../../static/front/css/lib/astillero/_formAud.css";
  import NauiSelect from "../../../lib/naui/atoms/NauiSelect.svelte";
  import NauiTextarea from "../../../lib/naui/atoms/NauiTextarea.svelte";
  import { onMount } from "svelte";
  import { createEventDispatcher } from "svelte";
  import {maxLenghtInput} from "../../../lib/utils/index";




  const dispatch = createEventDispatcher();

  export let estados;
  export let data;

  let validacionData={
    estado: data.estado,
    confeccion_observaciones: data.confeccion_observaciones,
    empaque_observaciones: data.empaque_observaciones,
    medidas_observaciones: data.medidas_observaciones,
  }

  function actualizarDatos() {
    dispatch("update", { label: "Validacion", data: { ...validacionData } });
  }

  onMount(() => {
    actualizarDatos();
    
  });
</script>

<div class="containerMain">
  <div class="Validation-content">
    <div class="description-estado">
      <p class="tittle-text">Estado:</p>
      <NauiSelect
      bind:value={validacionData.estado}
      options={estados}
      on:change={actualizarDatos}
      label="" />

    </div>

    <div class="description">
      <p class="tittle-text">Observaciones - Confección:</p>
      <NauiTextarea
        bind:value={validacionData.confeccion_observaciones}
        label=""
        class="textArea"
        on:input={(e) => {
          validacionData.confeccion_observaciones = maxLenghtInput(e, 2000);
          actualizarDatos();
        }}
      />
    </div>

    <div class="description">
      <p class="tittle-text">Observaciones - Empaque:</p>
      <NauiTextarea
        bind:value={validacionData.empaque_observaciones}
        label=""
        class="textArea"
        on:input={(e) => {
          validacionData.empaque_observaciones = maxLenghtInput(e, 2000);
          actualizarDatos();
        }}
      />
    </div>

    <div class="description">
      <p class="tittle-text">Observaciones - Medidas:</p>
      <NauiTextarea
        bind:value={validacionData.medidas_observaciones}
        label=""
        class="textArea"
        on:input={(e) => {
          validacionData.medidas_observaciones = maxLenghtInput(e, 2000);
          actualizarDatos();
        }}
      />
    </div>
  </div>
</div>

<style>
  .Validation-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 0px 15px;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .description {
    width: 100%;
    justify-content: center;
    align-items: center;
  }
  .description-estado {
    width: 20%;
    justify-content: center;
    align-items: center;
  }

  :global(.textArea .naui-field) {
    width: 100%;
  }

  :global(.textArea .naui-field-back) {
    width: 100%;
  }

  :global(.textArea .naui-input) {
    width: 100%;
    padding: 0.75rem;
    min-height: 25px;
    height: 68px;
    resize: none;
    background-color: white;
  }

  :global(.item-total.naui-field) {
    width: 49%;
  }
</style>
